import React from 'react'

export default function Star({color}) {
    return (
        <svg height='60' viewBox="0 0 170 97.08" xmlns="http://www.w3.org/2000/svg" >
            <g>
                <g>
                    <g>
                        <polygon points="144.04 17.24 158.84 4.06 154.52 0 144.04 17.24" fill={color}/>
                        <polygon points="150.2 24.28 170 23.04 168.6 16.11 150.2 24.28" fill={color}/>
                        <polygon points="149.5 34.59 168.37 37.51 166.08 43.24 149.5 34.59" fill={color}/>
                    </g>
                    <g>
                        <polygon points="26.43 76.77 13.11 91.43 17.84 95.02 26.43 76.77" fill={color}/>
                        <polygon points="19.56 70.43 0 73.75 2.13 80.49 19.56 70.43" fill={color}/>
                        <polygon points="19.16 60.1 .1 59.19 1.77 53.25 19.16 60.1" fill={color}/>
                    </g>
                    <path
                        d="M88.4,3.87l14.9,26.7,29.99,5.92c2.16.43,3.01,3.05,1.52,4.67l-20.79,22.42,3.64,30.36c.26,2.18-1.97,3.81-3.97,2.88l-27.75-12.84-27.75,12.84c-2,.92-4.23-.7-3.97-2.88l3.64-30.36-20.79-22.42c-1.5-1.61-.64-4.24,1.52-4.67l29.99-5.92,14.9-26.7c1.07-1.92,3.84-1.92,4.91,0Z"
                        fill={color}/>
                </g>
            </g>
        </svg>
    )
}
